"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TASK_RELIABILITY_CONFIG = void 0;
exports.createValidityEvaluator = createValidityEvaluator;
// @ts-ignore
const roar_utils_1 = require("@bdelab/roar-utils");
const taskStore_1 = require("../../../taskStore");
exports.TASK_RELIABILITY_CONFIG = {
    trog: {
        1: {
            responseTimeLowThreshold: 1500,
            accuracyThreshold: 0.65,
            minResponsesRequired: 10,
            includedReliabilityFlags: ['notEnoughResponses', 'accuracyTooLowAndResponseTimeTooFast'],
            customValidations: [
                {
                    logicalOperation: 'and',
                    conditions: [
                        (data) => data.existingFlags.includes('responseTimeTooFast'),
                        (data) => data.existingFlags.includes('accuracyTooLow'),
                    ],
                    flag: 'accuracyTooLowAndResponseTimeTooFast',
                },
            ],
        },
    },
    'roar-inference': {
        1: {
            responseTimeLowThreshold: 500,
            accuracyThreshold: 0.5,
            minResponsesRequired: 10,
            includedReliabilityFlags: ['notEnoughResponses', 'accuracyTooLowAndResponseTimeTooFast'],
            customValidations: [
                {
                    logicalOperation: 'and',
                    conditions: [
                        (data) => data.existingFlags.includes('responseTimeTooFast'),
                        (data) => data.existingFlags.includes('accuracyTooLow'),
                    ],
                    flag: 'accuracyTooLowAndResponseTimeTooFast',
                },
            ],
        },
    },
};
function createValidityEvaluator(config) {
    var _a;
    const { task, scoringVersion } = (0, taskStore_1.taskStore)();
    const evaluateValidityInput = (_a = exports.TASK_RELIABILITY_CONFIG[task]) === null || _a === void 0 ? void 0 : _a[scoringVersion];
    if (!evaluateValidityInput) {
        throw new Error(`No reliability configuration found for task "${task}" version ${scoringVersion}`);
    }
    const evaluateValidity = (0, roar_utils_1.createEvaluateValidity)({
        ...evaluateValidityInput,
    });
    const handleEngagementFlags = (flags, reliable) => {
        var _a;
        if (config.firekit.run.started) {
            return (_a = config.firekit) === null || _a === void 0 ? void 0 : _a.updateEngagementFlags(flags, reliable);
        }
        return null;
    };
    return new roar_utils_1.ValidityEvaluator({
        evaluateValidity: evaluateValidity,
        handleEngagementFlags: handleEngagementFlags,
    });
}
